import React from "react";
import { useEffect, useState } from "react";
import DownloadModal from "./DownloadModal";

const DownloadAssetCard = ({
  title,
  imageSrc,
  indicatorColor,
  allInOneLink,
  dropboxLinks,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div className="download-assets-container" onClick={openModal}>
        <div className="top-section">
          <img src={imageSrc} alt={title} />
          <div className="top-section-gradient" />
          <svg
            className="top-section-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M3.61111 2.22222C2.84444 2.22222 2.22222 2.84444 2.22222 3.61111V16.3889C2.22222 17.1556 2.84444 17.7778 3.61111 17.7778H16.3889C17.1556 17.7778 17.7778 17.1556 17.7778 16.3889V12.2222C17.7778 11.9275 17.8948 11.6449 18.1032 11.4365C18.3116 11.2282 18.5942 11.1111 18.8889 11.1111C19.1836 11.1111 19.4662 11.2282 19.6746 11.4365C19.8829 11.6449 20 11.9275 20 12.2222V16.3889C20 17.3466 19.6195 18.2651 18.9423 18.9423C18.2651 19.6195 17.3466 20 16.3889 20H3.61111C2.65338 20 1.73488 19.6195 1.05767 18.9423C0.380455 18.2651 0 17.3466 0 16.3889V3.61111C0 2.65338 0.380455 1.73488 1.05767 1.05767C1.73488 0.380455 2.65338 0 3.61111 0H7.77778C8.07246 0 8.35508 0.117063 8.56345 0.325437C8.77183 0.533811 8.88889 0.816426 8.88889 1.11111C8.88889 1.4058 8.77183 1.68841 8.56345 1.89679C8.35508 2.10516 8.07246 2.22222 7.77778 2.22222H3.61111ZM12.2222 2.22222C11.9275 2.22222 11.6449 2.10516 11.4365 1.89679C11.2282 1.68841 11.1111 1.4058 11.1111 1.11111C11.1111 0.816426 11.2282 0.533811 11.4365 0.325437C11.6449 0.117063 11.9275 0 12.2222 0H18.8889C19.1836 0 19.4662 0.117063 19.6746 0.325437C19.8829 0.533811 20 0.816426 20 1.11111V7.77778C20 8.07246 19.8829 8.35508 19.6746 8.56345C19.4662 8.77183 19.1836 8.88889 18.8889 8.88889C18.5942 8.88889 18.3116 8.77183 18.1032 8.56345C17.8948 8.35508 17.7778 8.07246 17.7778 7.77778V3.79333L13.0078 8.56333C12.7982 8.76573 12.5176 8.87772 12.2262 8.87519C11.9349 8.87266 11.6562 8.75581 11.4502 8.5498C11.2442 8.34379 11.1273 8.06511 11.1248 7.77378C11.1223 7.48245 11.2343 7.20178 11.4367 6.99222L16.2067 2.22222H12.2222Z"
              fill="#C1C1C1"
            />
          </svg>
        </div>

        <div className="bottom-section">
          <div className="bottom-section-inner-wrapper">
            <div
              className="color-indicator"
              style={{ backgroundColor: indicatorColor }}
            />
            <div className="bottom-section-contents">{title}</div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <DownloadModal
          onClose={closeModal}
          title={title}
          allInOneLink={allInOneLink}
          dropboxLinks={dropboxLinks}
        />
      )}
    </>
  );
};
export default DownloadAssetCard;
